<!-- 新增/编辑角色弹框 -->
<template>
  <div class="add-role">
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="589px"
      style="margin-top:12vh;"
      class="option-dialog"
      :close-on-click-modal="false"
    >
      <div slot="title">{{type==1?'新增角色':'编辑角色'}}</div>
      <el-form :model="showParams" ref="myForm" label-width="110px" class="xForm" center>
        <el-form-item label="角色名" prop="roleName">
          <el-input
            clearable
            size="medium"
            v-model="showParams.roleName"
            autocomplete="off"
            maxlength="8"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="userId">
           <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            maxlength="30"
            show-word-limit
            resize="none"
            v-model="showParams.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel" class="cancel-btn">取消</el-button>
        <el-button type="primary" size="small" class="confirm-btn"  @click="confirm" >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {createRole,editRole} from '@/api/role/role.js'
export default {
  name: "OptionRole",
  data() {
    return {
      dialogVisible: false,
      showParams: {},
      type: 1,
    };
  },
  methods: {
    open(data) {
      if(data && data!= null) {
        // 编辑
        this.type = 2;
        this.showParams = JSON.parse(JSON.stringify(data))
      }else {
        // 新增
        this.type = 1;
        this.resetParams();
      }
      this.dialogVisible = true;
    },
     // 重置数据
    resetParams() {
      this.showParams = {
        roleName: "",
        remark: "",
      }
    },
    // 确定事件
    confirm() {
      if(this.showParams.roleName && this.showParams.remark) {
        if(this.type == 1) {
          // 新增分类确定事件
          this.addRole(this.showParams)
        }else {
          // 编辑分类确定事件
          this.$confirm("您确定修改该角色？提交后将无法撤回", {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning',
            iconClass: 'el-icon-warning',
            customClass: 'delete-messege',
            center: true
          })
          .then((res) => {
            this.editRole(this.showParams)
          })
          .catch((action) => {
            this.$message("取消编辑");
          });
        }
      }else {
        this.$message.warning("表单字段不能为空！")
      }
    },
    // 取消事件
    cancel() {
      this.resetParams();
      this.dialogVisible = false;
    },
    // 添加角色请求
    addRole(params) {
      let that = this;
      createRole(params,localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200){
          that.$message.success('角色添加成功！')
          that.resetParams();
          this.dialogVisible = false;
          this.$emit("createSuccess",'成功')
        }
      }).catch(err => {
        that.$message.error('角色添加失败，请重试！')
      })
    },
    // 修改角色
    editRole(params) {
      let that = this;
      editRole(params,localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200){
          that.$message.success('角色添加成功！')
          that.resetParams();
          this.dialogVisible = false;
          this.$emit("createSuccess",'成功')
        }
      }).catch(err => {
        that.$message.error('角色添加失败，请重试！')
      })
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/ .option-dialog {
  .el-dialog__body {
    padding: 21px 36px 28px;
  }
  .el-dialog__footer {
    padding: 0 36px 18px;
  }
  .el-form-item {
    margin-bottom: 18px;
  }
  .el-button {
    width: 120px;
    height: 40px;
    border-radius: 6px;
  }
  .cancel-btn {
    margin-right:10px;
    border: none;
    color: #5D86C4;
  }
  .confirm-btn {
    font-size: 14px;
    font-weight: bold;
  }
}
 
</style>